import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from '../../../utils/baseQuery';

const BE_URL_ROUTES = {
  REGISTER: 'api/auth/register',
  LOGIN: 'api/auth/login',
  VERIFY_EMAIL: 'api/auth/send-code',
  VERIFY_CODE: 'api/auth/verify-code',
  LOGOUT: 'api/auth/logout',
  RESET_PWD: 'api/auth/reset-password',
  // GET_PLAN: 'api/auth/plans',
};

type registerUserParams = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  organizationName: string;
  CRNumber: string;
  businessIndustry: string;
  website: string;
  companySize: string;
  captchaToken: any;
  planId: string;
  chargebeeId: string;
  planQuantity: string;
};

type verifyCodeParamType = {
  email: string;
  code: string;
  isResetPwd: boolean;
  password: string;
  firstName: string;
  lastName: string;
};

type verifyCodeBodyType = {
  email: string;
  code: string;
  password?: string;
  firstName?: string;
  lastName?: string;
};

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  endpoints: (builder) => ({
    // Register User
    registerUser: builder.mutation({
      query: ({
        firstName,
        lastName,
        email,
        phoneNumber,
        password,
        organizationName,
        CRNumber,
        businessIndustry,
        website,
        companySize,
        captchaToken,
        planId,
        chargebeeId,
        planQuantity,
      }: registerUserParams) => ({
        url: BE_URL_ROUTES.REGISTER,
        method: 'POST',
        body: {
          email,
          password,
          firstName,
          lastName,
          phoneNumber,
          organizationName,
          domain: website,
          captchaToken,
          regNumber: CRNumber,
          businessIndustry,
          companySize,
          packagesId: planId,
        },
      }),
    }),
    // Login User
    loginUser: builder.mutation({
      query: ({ email, password, captchaToken }) => ({
        url: BE_URL_ROUTES.LOGIN,
        method: 'POST',
        body: { email, password, captchaToken },
      }),
    }),
    // Verify Email (For New User) | Reset Password => (Email Verification)
    verifyEmail: builder.mutation({
      query: ({ email, isResetPwd = false }) => ({
        url: BE_URL_ROUTES.VERIFY_EMAIL,
        method: 'POST',
        body: { email, type: isResetPwd ? 'RESET PASSWORD' : 'EMAIL VERIFICATION' },
      }),
    }),
    // Verify Code (Email Verification) | Reset Password (Reset-Pwd)
    verifyCode: builder.mutation({
      query: ({
        email,
        code,
        isResetPwd = false,
        password,
        firstName,
        lastName,
      }: verifyCodeParamType) => {
        const body: verifyCodeBodyType = { email, code, firstName, lastName };
        if (isResetPwd && password) {
          delete body.firstName;
          delete body.lastName;
          body.password = password;
        }
        return {
          url: BE_URL_ROUTES.VERIFY_CODE,
          method: 'POST',
          body,
        };
      },
    }),
    // Reset Pwd
    resetPwd: builder.mutation({
      query: ({ email, code, password }: verifyCodeParamType) => {
        const body: verifyCodeBodyType = { email, code, password };
        return {
          url: BE_URL_ROUTES.RESET_PWD,
          method: 'POST',
          body,
        };
      },
    }),
    // Logout User
    logoutUser: builder.mutation({
      query: ({ email }) => ({
        url: BE_URL_ROUTES.LOGOUT,
        method: 'POST',
        body: { email },
      }),
    }),

    autoLoginUser: builder.mutation({
      query: ({ email, imPersonateToken, captchaToken }) => ({
        url: BE_URL_ROUTES.LOGIN,
        method: 'POST',
        body: { email, imPersonateToken, captchaToken },
      }),
    }),

    /*
    getPlan: builder.query({
      query: () => ({
        url: BE_URL_ROUTES.GET_PLAN,
        method: 'GET',
      }),
    }),
    */
  }),
});

export const {
  useRegisterUserMutation,
  useLoginUserMutation,
  useVerifyEmailMutation,
  useVerifyCodeMutation,
  useLogoutUserMutation,
  useResetPwdMutation,
  useAutoLoginUserMutation,
  // useGetPlanQuery,
} = authApi;
